

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';
  import { FILTERS } from "../helpers/filters";
  import "../helpers/helpers";

  import WrsLabel from './wrsControls/WrsLabel.vue';
  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  import WrsViLabel from './wrsControls/viControls/WrsViLabel.vue';
  import WrsViSelect from './wrsControls/viControls/WrsViSelect.vue';
  import WrsViSelectBig from './wrsControls/viControls/WrsViSelectBig.vue';
  import WrsViText from './wrsControls/viControls/WrsViText.vue';
  import WrsViTextArea from './wrsControls/viControls/WrsViTextArea.vue';
  import WrsViRadioGroup from './wrsControls/viControls/WrsViRadioGroup.vue';
  import WrsViDate from './wrsControls/viControls/WrsViDate.vue';
  import WrsViNumeric from './wrsControls/viControls/WrsViNumeric.vue';
  import WrsViCheckbox from './wrsControls/viControls/WrsViCheckbox.vue';

  import WrsFee from './wrsControls/WrsFee.vue';

  // STP
  import WrsStpAxleItem from './wrsControls/viControls/Stp/WrsAxleItem.vue';
  import WrsDimensionItem from './wrsControls/viControls/Stp/WrsDimensionItem.vue';
  import WrsSpacingItem from './wrsControls/viControls/Stp/WrsSpacingItem.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,

      'wrs-vi-select': WrsViSelect,
      'wrs-vi-select-big': WrsViSelectBig,
      'wrs-vi-text': WrsViText,
      'wrs-vi-radio-group': WrsViRadioGroup,
      'wrs-vi-textarea': WrsViTextArea,
      'wrs-vi-numeric': WrsViNumeric,
      'wrs-vi-checkbox': WrsViCheckbox,
      'wrs-label': WrsLabel,
      'wrs-vi-label': WrsViLabel,
      'wrs-vi-date': WrsViDate,

      'wrs-fee': WrsFee,

      'wrs-stp-axle-item': WrsStpAxleItem,
      'wrs-stp-dimension-item': WrsDimensionItem,
      'wrs-stp-spacing-item': WrsSpacingItem,
    },
  })

  export default class App extends Vue {
    public VM: any = {};

    // public test: number = 3;
    
    isEmptyObject(obj: any) {
      if (obj == null) return true;
      return Object.keys(obj).length === 0;
    }

    public STEPIDS: any = {
      stepVehicle: 1,
      stepAddVehicle: 2,
      stepModel: 3,
      stepRoute: 4,
      stepVehicleConfig: 5,
      stepWeight: 6,
      stepSpacing: 7,
      stepDimension: 8,
      stepPreview: 9,
      stepFinish: 10,
    };

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public loader: any = {
      loaded: false,
      loadedNoError: false,
      loading: false
    };
    public modelPermit: any = {
      vehicleConfigurationId: 0
    };

    // Mobile funcions
    public isMobile: boolean = false;
    onResize() {
      //window.innerWidth < 769
      if (window.innerWidth < 821)
        this.isMobile = true;
      else
        this.isMobile = false;
    }

    public expandedRows: any = [];
    public mobileRowExpanded: boolean = false;
    expandRow(index: any){ 
      const indexOfRow = this.expandedRows.indexOf(index)
      if(indexOfRow > -1){
        this.mobileRowExpanded = false;
        this.expandedRows.splice(indexOfRow,1);
        return;
      }
      this.mobileRowExpanded = true;
      this.expandedRows.push(index);
    }
    // Mobile funcions end

    //created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //  }
    //}

    mounted() {
      this.startWizard();
      this.onResize();
    }

    startWizard() {
      this.VM.currentStepId = this.STEPIDS.stepVehicle;
      this.loader.loaded = false;
      this.loader.loadedNoError = false;
      this.loader.loading = false;

      this.spacingIsRecalculated = false;
      this.weightIsRecalculated = false;

      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user:any) => {
            if(user) {
              this.emailVerified = authService.emailVerified();

              if(user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if(this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                        .then(response => {
                          this.clientData = response.data;
                          this.loadData()
                      })
                      .catch(error => console.log(error))

                  }
                }
                else {
                  authService.logout();
                }
              }
              // else in store.js user is redirected to email-not-verified page!
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })

      }
    }

    public async loadData() {
      this.weightIsRecalculated = false;
      this.dimensionIsRecalculated = false;
      this.modelPermit.vehicleConfigurationId = 0;
      this.selectedVehicle = {};
      this.selectedPermitModel = {};
      this.clearPermitModel(true);
      this.loader.loading = true;

      axios
        .get('permits/initViewModelStp/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => { this.VM = response.data; })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;
          if (this.loader.loadedNoError) {
            this.findVehicle();
          }
        });
    }

    //All Steps Related
    getStepDataRequest(stepId: number, initType: any, isFinish: boolean) {
      var i = 0;
      let dr = {
        clientId: this.clientData.clientId,
        olsUserId: this.clientData.olsUserId,
        regId: 0,
        vehicleProvinceId: 0,
        stepId: stepId,
        initType: initType,
        id: 0,
        modelPermitId: 0,
        hasMultiTrip: false,
        mtFromDate: "",
        unitNumber: "",
        hasFaop: false,
        faopWeight: 0,
        hasPmvi: false,
        routeId: -1,
        vehicleConfigurationId: -1,
        materialId: -1,
        materialDescription: "",
        noOfPassengers: -1,
        requestNotes: this.VM.requestNotes.value,
        weights: [] as any,
        spacings: [] as any,
        dimensions: [] as any,
        onAccounts: [] as any,
        ireByPlate: "",
        ireByVin: "",
        isNewOotVehicle: false,
        newOotVehicle: {} as any,
      };

      dr.vehicleProvinceId = this.VM.jurisdiction.value;

      if (initType == 77) {
        //IRE Search NT ZD4SBC00294001276, 10316

        // ireSearch is not working correctly in drupal if plate number is not all uppercase.
        if (this.VM.irePlateNumber.value != null || this.VM.irePlateNumber.value != "") {
          this.VM.irePlateNumber.value = this.VM.irePlateNumber.value.toString().toUpperCase();
        }

        dr.ireByPlate = this.VM.irePlateNumber.value.toString().toUpperCase();
        dr.ireByVin = this.VM.ireVin.value.toString().toUpperCase();
      }

      if (initType != 77) {
        dr.modelPermitId = this.getSelectedModelPermitId();

        if (stepId > this.STEPIDS.stepVehicle && !this.isEmptyObject(this.selectedVehicle)) {
          dr.regId = this.selectedVehicle.registrationId;
          dr.hasMultiTrip = this.selectedVehicle.hasMultiTrip;
          dr.hasFaop = this.selectedVehicle.hasFaop;
          dr.faopWeight = this.selectedVehicle.faopWeight;
          dr.hasPmvi = this.selectedVehicle.hasPmvi;
        }

        if (stepId >= this.STEPIDS.stepAddVehicle && this.newOotVehicleIsOk()) {
          let newOotVehicle = {
            vehicleTypeId: this.VM.avVehicleType.value,
            vehicleStyleId: this.VM.avVehicleStyle.value,
            vehicleColorId: this.VM.avVehicleColor.value,
            unitNumber: this.VM.avUnitNumber.value,
            year: this.VM.avYear.value,
            makeId: this.VM.avMake.value,
            modelId: this.VM.avModel.value,
            effectiveDate: FILTERS.dateToString(this.VM.avEffectiveDate.value),
            expiryDate: FILTERS.dateToString(this.VM.avExpiryDate.value),
            plateNumber: this.VM.avPlateNumber,
            vin: this.VM.avVin,
          }
          dr.newOotVehicle = newOotVehicle;
          dr.isNewOotVehicle = true;
        }

        if (initType == 1) {
          //step init request
          if (stepId >= this.STEPIDS.stepWeight) {
            dr.vehicleConfigurationId = this.VM.vehicleConfig.value;
            dr.routeId = this.VM.route.value;
          }

          if (stepId >= this.STEPIDS.stepSpacing) {
            for (i = 0; i < this.VM.configAxles.length; i++) {
              dr.weights.push({
                axleTypeId: this.VM.configAxles[i].axleTypeId,
                orderNo: i + 1,
                actualWeight: this.VM.configAxles[i].value
              });
            }
          }

          if (stepId >= this.STEPIDS.stepDimension) {
            for (i = 0; i < this.VM.configSpacings.length; i++) {
              if (this.VM.configSpacings[i].isVisible) {
                dr.spacings.push({
                  orderNo: this.VM.configSpacings[i].orderNumber,
                  spacing: this.VM.configSpacings[i].value,

                  axleOrderNumber: this.VM.configSpacings[i].axleOrderNumber,
                  minInterAxleSpacing: this.VM.configSpacings[i].minValue,
                  isInterAxle: this.VM.configSpacings[i].isInterAxle
                });
              }
            }
          }
        }
        else {
          //recalculate request
          if (stepId >= this.STEPIDS.stepVehicleConfig) {
            dr.vehicleConfigurationId = this.VM.vehicleConfig.value;
            if (this.VM.vehicleConfigIsBus) {
              dr.materialId = -1;
              dr.materialDescription = "";
              dr.noOfPassengers = this.VM.noOfPassengers.value;
            }
            else {
              dr.materialId = this.VM.material.value;
              dr.materialDescription = this.VM.materialDescription.value;
              dr.noOfPassengers = -1;
            }
          }
          if (stepId >= this.STEPIDS.stepWeight) {
            dr.routeId = this.VM.route.value;
            for (i = 0; i < this.VM.configAxles.length; i++) {
              dr.weights.push({
                axleTypeId: this.VM.configAxles[i].axleTypeId,
                orderNo: i + 1,
                actualWeight: this.VM.configAxles[i].value
              });
            }
          }
          if (stepId >= this.STEPIDS.stepSpacing) {
            for (i = 0; i < this.VM.configSpacings.length; i++) {
              if (this.VM.configSpacings[i].isVisible) {
                dr.spacings.push({
                  orderNo: this.VM.configSpacings[i].orderNumber,
                  spacing: this.VM.configSpacings[i].value,

                  axleOrderNumber: this.VM.configSpacings[i].axleOrderNumber,
                  minInterAxleSpacing: this.VM.configSpacings[i].minValue,
                  isInterAxle: this.VM.configSpacings[i].isInterAxle
                });
              }
            }
          }
          if (stepId >= this.STEPIDS.stepDimension) {
            for (i = 0; i < this.VM.dimensions.length; i++) {
              dr.dimensions.push({
                orderNo: i + 1,
                value: this.VM.dimensions[i].value
              });
            }
          }
        }
      }
      if (isFinish) { dr.initType = this.isAddToCart ? 99 : 88; }

      return dr;
    }

    newOotVehicleIsOk() {
      if (!this.VM.ireSearchExecuted || !this.VM.isNewOotVehicle) return false;

      return !this.VM.avVehicleType.hasError &&
        !this.VM.avVehicleStyle.hasError &&
        !this.VM.avVehicleColor.hasError &&
        !this.VM.avMake.hasError &&
        !this.VM.avModel.hasError &&
        !this.VM.avEffectiveDate.hasError &&
        !this.VM.avExpiryDate.hasError &&
        !this.VM.avUnitNumber.hasError &&
        !this.VM.avYear.hasError;
    }

    canGoToNextStep(currentStepId: number) {
      if (this.VM.runtimeError.hasError) return false;
      if (currentStepId == this.STEPIDS.stepVehicle) {
        var cnt = this.vehicleList.filter((item: any) => item.isSelected == true);
        return cnt.length > 0;
      }
      else if (currentStepId == this.STEPIDS.stepAddVehicle) {
        return this.newOotVehicleIsOk();
      }
      else if (currentStepId == this.STEPIDS.stepModel) {
        if (this.VM.modelByValue.value == 1 || this.VM.modelByValue.value == 3) {
          return true;
        }
        else {
          var cntPermit = this.permitModelList.filter((item: any) => item.isSelected == true);
          return cntPermit.length > 0;
        }
      }
      else if (currentStepId == this.STEPIDS.stepRoute) {
        return this.canGenerateRoute && this.routeIsOk;
      }
      else if (currentStepId == this.STEPIDS.stepVehicleConfig) {
        if (this.VM.vehicleConfigIsBus) {
          return !this.VM.vehicleConfig.hasError && !this.VM.noOfPassengers.hasError;
        }
        else {
          return !this.VM.vehicleConfig.hasError && !this.VM.material.hasError && !this.VM.materialDescription.hasError;
        }
      }
      else if (currentStepId == this.STEPIDS.stepWeight) {
        return this.weightIsRecalculated && this.configAxlesAreOk && !this.VM.runtimeError.hasError && !this.VM.stepWeight.alert.hasError;
      }
      else if (currentStepId == this.STEPIDS.stepSpacing) {
        return this.spacingIsRecalculated && this.configSpacingsAreOk && !this.VM.runtimeError.hasError && !this.VM.stepSpacing.alert.hasError;
      }
      else if (currentStepId == this.STEPIDS.stepDimension) {
        return this.dimensionIsRecalculated && this.dimensionsAreOk;
      }
      else if (currentStepId == this.STEPIDS.stepPreview) {
        return !this.VM.isEmptyPermit && !this.VM.stepPreview.alert.hasAny && this.VM.disclamer?.value;
      }

      return false;
    }
    loadNextStep(stepId: number) {
      if (!this.canGoToNextStep(stepId)) return;

      if (stepId == this.STEPIDS.stepVehicle) {
        this.VM.currentStepId = this.STEPIDS.stepModel;
      }
      else if (stepId == this.STEPIDS.stepAddVehicle) {
        this.VM.currentStepId = this.STEPIDS.stepModel;
      }
      else if (stepId == this.STEPIDS.stepModel) {
        let dr = this.getStepDataRequest(stepId, 1, false);

        if (dr.modelPermitId > 0) {
          this.loadBasedOnModel(stepId);
        }
        else {
          this.VM.currentStepId = this.STEPIDS.stepRoute;
          dr.stepId = this.STEPIDS.stepRoute;

          //loading lookups for route
          this.loader.loading = true;
          axios
            .post('permits/getStpStepData', dr)
            .then(response => {
              this.VM.originType = response.data.originType;
              this.VM.originSection = response.data.originSection;
              this.VM.originKm = response.data.originKm;

              this.VM.destinationType = response.data.destinationType;
              this.VM.destinationSection = response.data.destinationSection;
              this.VM.destinationKm = response.data.destinationKm;
            })
            .catch(error => console.log(error))
            .finally(() => {
              this.loader.loading = false;
            });
        }
      }
      else if (stepId == this.STEPIDS.stepRoute) {
        this.VM.currentStepId = this.STEPIDS.stepVehicleConfig;
      }
      else if (stepId == this.STEPIDS.stepVehicleConfig) {
        this.VM.currentStepId = this.STEPIDS.stepWeight;

        let selectedVehicleConfigurationId = -1; // this.VM.vehicleConfig.value == null ? -1 : this.VM.vehicleConfig.value;

        if (this.modelPermit.vehicleConfigurationId == 0 || this.modelPermit.vehicleConfigurationId != selectedVehicleConfigurationId) {

          //loading step weight data
          this.loader.loading = true;
          let dr = this.getStepDataRequest(this.STEPIDS.stepWeight, 1, false);
          axios
            .post('permits/getStpStepData', dr)
            .then(response => {
              this.VM.configAxles = response.data.configAxles;
              this.VM.configSpacings = response.data.configSpacings;
              this.weightRelatedPropertyChanged();
            })
            .catch(error => console.log(error))
            .finally(() => {
              this.loader.loading = false;
            });
        }
      }
      else if (stepId == this.STEPIDS.stepWeight) {
        this.VM.currentStepId = this.STEPIDS.stepSpacing;

        let selectedVehicleConfigurationId = this.VM.vehicleConfig.value == null ? -1 : this.VM.vehicleConfig.value;
        if (this.modelPermit.vehicleConfigurationId == 0 || this.modelPermit.vehicleConfigurationId != selectedVehicleConfigurationId) {
          //loading step dimension data
          this.loader.loading = true;
          let dr = this.getStepDataRequest(this.STEPIDS.stepSpacing, 1, false);

          axios
            .post('permits/getStpStepData', dr)
            .then(response => {
              this.VM.configSpacings = response.data.configSpacings;
            })
            .catch(error => console.log(error))
            .finally(() => {
              this.loader.loading = false;
            });
        }
      }
      else if (stepId == this.STEPIDS.stepSpacing) {
        this.VM.currentStepId = this.STEPIDS.stepDimension;

        let selectedVehicleConfigurationId = this.VM.vehicleConfig.value == null ? -1 : this.VM.vehicleConfig.value;
        if (this.modelPermit.vehicleConfigurationId == 0 || this.modelPermit.vehicleConfigurationId != selectedVehicleConfigurationId) {
          //loading step dimension data
          this.loader.loading = true;
          let dr = this.getStepDataRequest(this.STEPIDS.stepDimension, 1, false);

          axios
            .post('permits/getStpStepData', dr)
            .then(response => {
              this.VM.dimensions = response.data.dimensions;
            })
            .catch(error => console.log(error))
            .finally(() => {
              this.loader.loading = false;
            });
        }
      }
      else if (stepId == this.STEPIDS.stepDimension) {
        this.VM.currentStepId = this.STEPIDS.stepPreview;

        //calculate everything and do a preview
        this.loader.loading = true;
        let dr = this.getStepDataRequest(this.STEPIDS.stepPreview, 2, false);

        axios
          .post('permits/getStpStepData', dr)
          .then(response => {
            this.VM.requiresApproval = response.data.requiresApproval;
            this.VM.approvalList = response.data.approvalList;
            this.VM.calculatedFees = response.data.calculatedFees;
            this.VM.conditions = response.data.conditions;
            this.VM.permitCart = response.data.permitCart;
            this.VM.disclamer = response.data.disclamer;

            this.VM.isEmptyPermit = response.data.isEmptyPermit;
            this.VM.stepPreview.alert = response.data.stepPreview.alert;
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
          });
      }
    }

    loadBasedOnModel(stepId: number) {
      let dr = this.getStepDataRequest(stepId, 1, false);
      this.selectedPermitModel = {}; // we load model and we clear selection here so it does not model again
      this.VM.currentStepId = this.STEPIDS.stepRoute;
      dr.stepId = this.STEPIDS.stepModel;

      this.loader.loading = true;
      axios
        .post('permits/getStpStepData', dr) //xxx
        .then(response => {
          //route
          this.VM.originType = response.data.originType;
          this.VM.originSection = response.data.originSection;
          this.VM.originKm = response.data.originKm;

          this.VM.destinationType = response.data.destinationType;
          this.VM.destinationSection = response.data.destinationSection;
          this.VM.destinationKm = response.data.destinationKm;

          this.VM.route = response.data.route;

          //config
          this.VM.vehicleConfig = response.data.vehicleConfig;
          this.VM.material = response.data.material;
          this.VM.materialDescription = response.data.materialDescription;
          this.VM.vehicleConfigIsBus = response.data.vehicleConfigIsBus;
          this.VM.noOfPassengers = response.data.noOfPassengers;

          this.modelPermit.vehicleConfigurationId = response.data.vehicleConfig == null ? 0 : response.data.vehicleConfig.value;

          this.VM.configAxles = response.data.configAxles;
          this.VM.configSpacings = response.data.configSpacings;

          this.VM.dimensions = response.data.dimensions;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    //#region Find Vehicle Step
    public selectedVehicle: any = {};
    public vehicleList: any = [];

    //getters
    get findVehicleHideDefaultFooter() {
      if (this.vehicleList) {
        return this.vehicleList.length < 10;
      }
      return true;
    }

    //methods
    searchParamChanged() {
      this.selectedVehicle = {};
      this.vehicleList = [];
      GF.clearAlert(this.VM.stepVehicle.alert);
    }

    findVehicle() {
      let provinceId = this.VM.jurisdiction.value;
      let plateNumber = '%20';
      if (this.VM.plateNumber.value != "") plateNumber = this.VM.plateNumber.value;

      let unitNumber = '%20';
      if (this.VM.unitNumber.value != "") unitNumber = this.VM.unitNumber.value;

      this.loader.loading = true;

      axios
        .get('permits/vehiclesearch/' + this.clientData.olsUserId + '/' + this.clientData.clientId + '/' + provinceId + '/' + plateNumber + '/' + unitNumber)
        .then(response => (this.vehicleList = response.data))
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          if (this.vehicleList.length == 0) {
            GF.setAlertError(this.VM.stepVehicle.alert, this.VM.wizardMessages.VehicleSearchNoneFound);
          }
          else {
            GF.setAlertError(this.VM.stepVehicle.alert, "");
          }
        });
    }
    clearFindVehicle() {
      this.selectedVehicle = {};
      GF.setAlertError(this.VM.stepVehicle.alert, "");

      this.VM.jurisdiction.value = this.clientData.provinceId;
      this.VM.plateNumber.value = "";
      this.VM.unitNumber.value = "";

      this.findVehicle();
    }
    selectVehicle(id: number) {
      var index, len;
      this.selectedVehicle = {};

      for (index = 0, len = this.vehicleList.length; index < len; ++index) {
        if (this.vehicleList[index].id == id) {
          this.vehicleList[index].isSelected = true;
          this.selectedVehicle = this.vehicleList[index];
        }
        else
          this.vehicleList[index].isSelected = false;
      }
    }
    getVehicleTableHeaders() {
      return [
        { text: '', value: 'isSelected', sortable: false, width: '50px' },
        { text: this.VM.wizardLabels.PlateNo, value: 'plateNumber', align: 'start', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.VehicleInfo, value: 'vehicleInfoGrid', sortable: false, width: '' }, //400px
        { text: this.VM.wizardLabels.ExpiryDate, value: 'expiryDate', width: '', sortable: false }, //120px
        { text: this.VM.wizardLabels.Details, value: 'data-table-expand', sortable: false },
      ];
    }
    //#endregion

    //#region Add Vehicle Step
    get canAddVehicle() {
      if (!this.loader.loaded) return false;
      if (this.VM.runtimeError.hasError) return false;
      if (this.VM.jurisdiction.hasError) return false;
      return this.VM.jurisdiction.value != this.VM.homeProvinceId;
    }
    get ireCheckDisabled() {
      if (this.VM.currentStepId != this.STEPIDS.stepAddVehicle) return false;
      if (!this.VM.isNewVehicle) return false;

      return this.VM.irePlateNumber.hasError || this.VM.ireVin.hasError;
    }
    ireCheck() {
      this.loader.loading = true;
      this.VM.currentStepId = this.STEPIDS.stepAddVehicle;
      let dr = this.getStepDataRequest(this.STEPIDS.stepAddVehicle, 77, false); //IreSearch

      axios
        .post('permits/getStpStepData', dr)
        .then(response => {
          this.VM.avVehicleType = response.data.avVehicleType;
          this.VM.avVehicleStyle = response.data.avVehicleStyle;
          this.VM.avVehicleColor = response.data.avVehicleColor;

          this.VM.avUnitNumber = response.data.avUnitNumber;
          this.VM.avYear = response.data.avYear;
          this.VM.avMake = response.data.avMake;
          this.VM.avModel = response.data.avModel;
          this.VM.avEffectiveDate = response.data.avEffectiveDate;
          this.VM.avExpiryDate = response.data.avExpiryDate;

          this.VM.avPlateNumber = response.data.avPlateNumber;
          this.VM.avVin = response.data.avVin;

          this.VM.ireSearchExecuted = response.data.ireSearchExecuted;
          this.VM.isNewOotVehicle = response.data.isNewOotVehicle;

          this.VM.stepAddVehicle.alert = response.data.stepAddVehicle.alert;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    clearIreCheck() {
      this.VM.irePlateNumber.value = "";
      this.VM.ireVin.value = "";
      this.VM.ireSearchExecuted = false;
      this.VM.isNewOotVehicle = false;
      GF.clearAlert(this.VM.stepAddVehicle.alert);
    }

    loadAddVehicleStep() {
      this.loader.loading = true;
      this.VM.currentStepId = this.STEPIDS.stepAddVehicle;
      let dr = this.getStepDataRequest(this.STEPIDS.stepAddVehicle, 1, false);

      axios
        .post('permits/getStpStepData', dr)
        .then(response => {
          this.VM.irePlateNumber = response.data.irePlateNumber;
          this.VM.ireVin = response.data.ireVin;
          this.VM.isNewVehicle = true;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    avMakeChanged() {
      this.loader.loading = true;
      let makeId = 0;
      if (!this.VM.avMake.hasError) makeId = this.VM.avMake.value;

      axios
        .get('permits/GetVehicleModels/' + makeId)
        .then(response => {
          this.VM.avModel = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    public avDatesCheckResult: any = [];
    get avEffectiveDateExternalError() {
      if (this.avDatesCheckResult.length < 1) return "";

      return this.avDatesCheckResult[0].errorMessage;
    }
    get avExpiryDateExternalError() {
      if (this.avDatesCheckResult.length < 2) return "";

      return this.avDatesCheckResult[1].errorMessage;
    }

    checkAvDates() {
      let dr = {
        dates: [] as any,
      };

      let fromDate = {
        "date1Label": this.VM.avEffectiveDate.label,
        "date1Value": this.VM.avEffectiveDate.value,
        "date2Label": this.VM.avExpiryDate.label,
        "date2Value": this.VM.avExpiryDate.value,
        "canBeInthePast": true,
        "canBeIntheFuture": false,
        "canBeBeforeDate2": true,
        "canBeAfterDate2": false,
        "errorMessage": ""
      }
      dr.dates.push(fromDate);

      let toDate = {
        "date1Label": this.VM.avExpiryDate.label,
        "date1Value": this.VM.avExpiryDate.value,
        "date2Label": this.VM.avEffectiveDate.label,
        "date2Value": this.VM.avEffectiveDate.value,
        "canBeInthePast": false,
        "canBeIntheFuture": true,
        "canBeBeforeDate2": false,
        "canBeAfterDate2": true,
        "errorMessage": ""
      }
      dr.dates.push(toDate);

      axios
        .post('lookups/checkdates', dr)
        .then(response => {
          this.avDatesCheckResult = response.data.dates;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    //#endregion
    //#region Permit Model
    //data
    public selectedPermitModel: any = {};
    public permitModelList: any = [];

    //getters
    get permitModelHideDefaultFooter() {
      if (this.permitModelList) {
        return this.permitModelList.length < 10;
      }
      return false;
    }

    //methods
    selectPermitModel(id: number) {
      var index, len;
      this.selectedPermitModel = {};
      for (index = 0, len = this.permitModelList.length; index < len; ++index) {
        if (this.permitModelList[index].permitId == id) {
          this.permitModelList[index].isSelected = true;
          this.selectedPermitModel = this.permitModelList[index];
        }
        else
          this.permitModelList[index].isSelected = false;
      }
    }
    findPermitModel() {
      let permitNumber = this.VM.modelOnPermitNumber.value;
      GF.setAlertError(this.VM.stepModel.alert, "");

      this.loader.loading = true;

      axios
        .get('permits/getpermitmodels/' + this.clientData.clientId + '/' + permitNumber)
        .then(response => (this.permitModelList = response.data))
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          if (this.permitModelList.length == 0) {
            GF.setAlertError(this.VM.stepModel.alert, this.VM.wizardMessages.PermitModelNoneFound);
          }
          else {
            GF.setAlertError(this.VM.stepModel.alert, "");
          }
        });

    }
    clearPermitModel(isOnLoad: boolean) {
      this.selectedPermitModel = {};
      if (!isOnLoad) {
        GF.setAlertError(this.VM.stepModel.alert, "");
        this.VM.modelOnPermitNumber.value = "";
      }

      this.permitModelList = [];

    }
    getSelectedModelPermitId() {
      if (this.VM.modelByValue.value == 2) {
        var cntPermit = this.permitModelList.filter((item: any) => item.isSelected == true);
        if (cntPermit.length > 0) return cntPermit[0].permitId;
      }
      return 0;
    }
    getPermitModelTableHeaders() {
      return [
        { text: '', value: 'isSelected', sortable: false, width: '50px' }, //50px
        { text: this.VM.wizardLabels.PermitNo, value: 'permitNumber', align: 'start', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.VersionNo, value: 'versionNumber', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.TypeDescription, value: 'typeDescription', sortable: false, width: '' }, //150px
        { text: this.VM.wizardLabels.Description, value: 'permitDescription', sortable: false, width: '' }, //50px
      ];
    }
    //#endregion

    //#region Vehicle Config Step
    //methods
    vehicleConfigPropertyChanged(propertyName: String) {
      if (propertyName == "Config") {
        this.VM.vehicleConfigIsBus = false;
        let configRecord = this.VM.vehicleConfig.items.find((element: any) => element.id == this.VM.vehicleConfig.value);
        if (configRecord) {
          this.VM.vehicleConfigIsBus = configRecord.rec.isBus;
        }
      }
      else if (propertyName == "Material") {
        this.VM.materialDescription.isRequired = false;
        if (this.VM.material.value != null && this.VM.material.value > 0) {
          let materialRecord = this.VM.material.items.find((element: any) => element.id == this.VM.material.value);
          if (materialRecord) {
            this.VM.materialDescription.isRequired = materialRecord.rec.isDescriptionRequired;
          }
        }
      }
    }
    //#endregion

    //#region Route Step
    //data
    public defualtRoute: any = {
      routeId: 0,
      routeName: "",
      routeLength: "0km",
      territoryRouteLength: "0km",
      isFuelTaxExempt: false,
      containsClosed: false,
      containsRestriction: false,
      routeRestrictedPercent: 0
    };

    //getters
    get canGenerateRoute() {
      let originIsOk = !this.VM.originType.hasError && !this.VM.originSection.hasError;
      if (this.VM.originType.value == 5) originIsOk = originIsOk && !this.VM.originKm.hasError;

      let destinationIsOk = !this.VM.destinationType.hasError && !this.VM.destinationSection.hasError;
      if (this.VM.destinationType.value == 5) destinationIsOk = destinationIsOk && !this.VM.destinationKm.hasError;

      return originIsOk && destinationIsOk;
    }
    get hasSelectedRoute() {
      /*return !isNaN(this.VM.route.value) && this.VM.route.value > 0 && !this.VM.route.containsClosed;*/
      return this.selectedRoute.routeId > 0;
    }
    get routeIsOk() {
      return this.selectedRoute.routeId > 0 && !this.selectedRoute.containsClosed; // && !this.selectedRoute.containsRestriction;
    }
    get selectedRoute() {
      try {
        let r = this.VM.route.items.find((element: any) => element.id == this.VM.route.value);
        if (r == null)
          return this.defualtRoute;
        else
          return r.rec;
      }
      catch (error) {
        return this.defualtRoute;
      }
    }

    //methods
    clearRoute() {
      this.VM.route.items = [];
      this.VM.route.value = null;
      GF.clearAlert(this.VM.stepRoute.alert);
      GF.clearAlert(this.VM.runtimeError);
    }
    checkSelectedRoute() {
      if (this.selectedRoute.containsClosed) {
        GF.setAlertError(this.VM.stepRoute.alert, this.VM.wizardLabels.ClosedSectonOnRoute);
      }
      else {
        GF.clearAlert(this.VM.stepRoute.alert);
      }
    }

    routeTypeChanged(propertyName: String) {
      this.clearRoute();
      let dr = this.getStepDataRequest(this.STEPIDS.stepRoute, 0, false);

      if (propertyName == "Origin") {
        dr.id = this.VM.originType.value;
        dr.initType = 3;
        this.loader.loading = true;
        axios
          .post('permits/getStpStepData', dr)
          .then(response => {
            this.VM.originSection = response.data.originSection;
            this.routeSectionChanged(propertyName);
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
          });
      }
      else if (propertyName == "Destination") {
        dr.id = this.VM.destinationType.value;
        dr.initType = 4;
        this.loader.loading = true;
        axios
          .post('permits/getStpStepData', dr)
          .then(response => {
            this.VM.destinationSection = response.data.destinationSection;
            this.routeSectionChanged(propertyName);
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
          });
      }
    }

    routeSectionChanged(propertyName: String) {
      this.clearRoute();

      if (propertyName == "Origin") {
        this.VM.originKm.value = null;
        if (this.VM.originType.value == 5 && this.VM.originSection.value != null) {
          //KM
          let originSectionRecord = this.VM.originSection.items.find((element: any) => element.id == this.VM.originSection.value);
          if (originSectionRecord) {
            this.VM.originKm.value = originSectionRecord.rec.fromKm;
            this.VM.originKm.minValue = originSectionRecord.rec.fromKm;
            this.VM.originKm.maxValue = originSectionRecord.rec.toKm;
          }
        }
      }
      else if (propertyName == "Destination") {
        this.VM.destinationKm.value = null;
        if (this.VM.destinationType.value == 5 && this.VM.destinationSection.value != null) {
          //KM
          let destinationSectionRecord = this.VM.destinationSection.items.find((element: any) => element.id == this.VM.destinationSection.value);
          if (destinationSectionRecord) {
            this.VM.destinationKm.value = destinationSectionRecord.rec.fromKm;
            this.VM.destinationKm.minValue = destinationSectionRecord.rec.fromKm;
            this.VM.destinationKm.maxValue = destinationSectionRecord.rec.toKm;
          }
        }
      }
    }
    generateRoute() {
      let routeRequest = {
        includeLowPriorityRoutes: false,
        selectedRouteId: -1,

        originIsKm: false,
        originRoadId: -1,
        originRoadSectionId: -1,
        originKm: -1,

        destinationIsKm: false,
        destinationRoadId: -1,
        destinationRoadSectionId: -1,
        destinationKm: -1
      };

      routeRequest.includeLowPriorityRoutes = this.VM.routeByRoadType.value == 2;

      let originSectionRecord = this.VM.originSection.items.find((element: any) => element.id == this.VM.originSection.value);
      routeRequest.originRoadId = originSectionRecord.rec.roadId;
      routeRequest.originRoadSectionId = originSectionRecord.rec.roadSectionId;
      if (this.VM.originType.value == 5) {
        routeRequest.originIsKm = true;
        routeRequest.originKm = this.VM.originKm.value;
      }

      let destinationSectionRecord = this.VM.destinationSection.items.find((element: any) => element.id == this.VM.destinationSection.value);
      routeRequest.destinationRoadId = destinationSectionRecord.rec.roadId;
      routeRequest.destinationRoadSectionId = destinationSectionRecord.rec.roadSectionId;
      if (this.VM.destinationType.value == 5) {
        routeRequest.destinationIsKm = true;
        routeRequest.destinationKm = this.VM.destinationKm.value;
      }
      this.loader.loading = true;
      GF.clearAlert(this.VM.stepRoute.alert);
      axios
        .post('permits/generateroute', routeRequest)
        .then(response => {
          this.VM.route = response.data.route;
          this.VM.runtimeError = response.data.runtimeError;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          if (!this.VM.runtimeError.hasAny) {
            this.checkSelectedRoute();
          }
        });
    }
    //#endregion

    //#region Weight Step
    //data
    public weightIsRecalculated: Boolean = false;

    //getters
    get canRecalculateWeight() {
      if (this.weightIsRecalculated) return false;
      return this.configAxlesAreOk;
    }
    get configAxlesAreOk() {
      let isOk = true;
      var i = 0;

      if (this.VM.configAxles) {
        for (i = 0; i < this.VM.configAxles.length; i++) {
          if (this.VM.configAxles[i].hasError) isOk = false;
        }
      }
      return isOk;
    }

    //methods
    public hasAnyRestricted = false;
    weightRelatedPropertyChanged() {
      this.weightIsRecalculated = false;
      this.VM.runtimeError.hasAny = false;
      this.hasAnyRestricted = false;

      var axlesCount = 0;
      for (var i = 0; i < this.VM.configAxles.length; i++) {
        let axleTypeRecord = this.VM.configAxles[i].axles.find((element: any) => element.axleTypeId == this.VM.configAxles[i].axleTypeId);
        if (axleTypeRecord) axlesCount = axlesCount + axleTypeRecord.numberOfAxles;
      }

      let restrictedRecord = this.VM.configAxles.find((element: any) => element.isRestricted == true);
      if (restrictedRecord) this.hasAnyRestricted = true;
    }
    recalculateWeight() {
      var dr = this.getStepDataRequest(this.STEPIDS.stepWeight, 2, false);

      axios
        .post('permits/getStpStepData', dr)
        .then(response => {
          this.VM.wd = response.data.wd;
          this.VM.runtimeError = response.data.runtimeError;
          this.weightIsRecalculated = true;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });

    }
    getConfigAxlesTableHeaders() {
      let caRecord = this.VM.configAxles.find((element: any) => element.restricted != null && element.restricted > 0);
      if (caRecord == null) {
        return [
          { text: this.VM.wizardLabels.Position, value: 'label', align: 'start', width: '', sortable: false }, //200px
          { text: this.VM.wizardLabels.AxleType, value: 'axleTypeId', width: '', sortable: false }, //350px
          { text: this.VM.wizardLabels.LegalWeightTableHeader, value: 'legal', width: '', sortable: false }, //120px
          { text: this.VM.wizardLabels.ActualWeightTableHeader, value: 'value', width: '', sortable: false }, //120px
        ];
      }
      else {
        return [
          { text: this.VM.wizardLabels.Position, value: 'label', align: 'start', width: '', sortable: false }, //200px
          { text: this.VM.wizardLabels.AxleType, value: 'axleTypeId', width: '', sortable: false }, //350px
          { text: this.VM.wizardLabels.LegalWeightTableHeader, value: 'legal', width: '', sortable: false }, // 120px
          { text: this.VM.wizardLabels.Restricted, value: 'restricted', width: '', sortable: false }, //120px
          { text: this.VM.wizardLabels.ActualWeightTableHeader, value: 'value', width: '', sortable: false }, //120px
        ];
      }
    }

    getAxleName(axleItem: any) {
      let item = axleItem.axles.find((element: any) => element.axleTypeId == axleItem.axleTypeId);
      if (item) {
        return item.axleTypeName;
      }
      else {
        return "";
      }
    }

    //#endregion

    //#region Spacing Step
    //data
    public spacingIsRecalculated: Boolean = false;

    //getters
    get canRecalculateSpacing() {
      if (this.spacingIsRecalculated) return false;
      return this.configSpacingsAreOk;
    }
    get configSpacingsAreOk() {
      let isOk = true;
      var i = 0;

      if (this.VM.configSpacings) {
        for (i = 0; i < this.VM.configSpacings.length; i++) {
          if (this.VM.configSpacings[i].isVisible && this.VM.configSpacings[i].hasError) isOk = false;
        }
      }
      return isOk;
    }

    //methods
    spacingRelatedPropertyChanged() {
      this.spacingIsRecalculated = false;
      this.VM.runtimeError.hasAny = false;

      var axlesCount = 0;
      for (var i = 0; i < this.VM.configAxles.length; i++) {
        let axleTypeRecord = this.VM.configAxles[i].axles.find((element: any) => element.axleTypeId == this.VM.configAxles[i].axleTypeId);
        if (axleTypeRecord) axlesCount = axlesCount + axleTypeRecord.numberOfAxles;
      }

      for (var j = 0; j < this.VM.configSpacings.length; j++) {
        if (this.VM.configSpacings[j].orderNumber < axlesCount) {
          this.VM.configSpacings[j].isVisible = true;
        }
        else {
          this.VM.configSpacings[j].isVisible = false;
          this.VM.configSpacings[j].value = 0;
        }
      }
    }
    recalculateSpacing() {
      var dr = this.getStepDataRequest(this.STEPIDS.stepSpacing, 2, false);

      axios
        .post('permits/getStpStepData', dr)
        .then(response => {
          this.VM.wd = response.data.wd;
          this.VM.runtimeError = response.data.runtimeError;
          this.spacingIsRecalculated = true;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });

    }
    //#endregion

    //#region Dimension Step
    //data
    public dimensionIsRecalculated: Boolean = false;

    //getters
    get dimensionsAreOk() {
      let isOk = true;
      var i = 0;

      if (this.VM.dimensions) {
        for (i = 0; i < this.VM.dimensions.length; i++) {
          if (this.VM.dimensions[i].hasError) isOk = false;
        }
      }
      return isOk;
    }
    get canRecalculateOD() {
      if (this.dimensionIsRecalculated) return false;
      return this.dimensionsAreOk;
    }

    //methods
    dimensionRelatedPropertyChanged() {
      this.dimensionIsRecalculated = false;
      this.VM.runtimeError.hasAny = false;
    }
    recalculateOD() {
      var dr = this.getStepDataRequest(this.STEPIDS.stepDimension, 2, false);

      axios
        .post('permits/getStpStepData', dr)
        .then(response => {
          this.VM.od = response.data.od;
          this.VM.stepDimension.alert = response.data.stepDimension.alert;
          this.dimensionIsRecalculated = !this.VM.stepDimension.alert.hasError;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });

    }
    getDimensionTableHeaders() {
      return [
        { text: '', value: 'rowLabel', align: 'start', width: '80px', sortable: false },
        { text: this.VM.wizardLabels.Min, value: 'minValue', width: '100px', sortable: false },
        { text: this.VM.wizardLabels.Max, value: 'maxValue', width: '100px', sortable: false },
        { text: this.VM.wizardLabels.Road, value: 'roadValue', width: '100px', sortable: false },
        { text: this.VM.wizardLabels.Actual, value: 'value', width: '100px', sortable: false },
      ];
    }
    //#endregion

    //#region Preview Step
    //getters
    get isAddToCart() {
      if (this.VM.currentStepId != this.STEPIDS.stepPreview) return false;
      if (this.VM.requiresApproval) return false;
      return true;
    }

    get finalText() {
      if (this.VM.currentStepId != this.STEPIDS.stepPreview) return "";
      if (this.VM.requiresApproval) return this.VM.wizardLabels.SendForApproval;
      return this.VM.wizardLabels.AddToShoppigCart;
    }

    //methods
    addToCartOrSendForReview() {
      //sned for review or add to cart
      this.loader.loading = true;
      let dr = this.getStepDataRequest(this.STEPIDS.stepPreview, 2, true);


      for (var i = 0; i < this.VM.permitCart.calculatedFees.length; i++) {
        if (this.VM.permitCart.calculatedFees[i].onAccountId != null && this.VM.permitCart.calculatedFees[i].onAccountId > 0) {
          dr.onAccounts.push({
            id: this.VM.permitCart.calculatedFees[i].onAccountId,
            permitCartItemId: this.VM.permitCart.calculatedFees[i].permitCartItemId,
            text: "",
          });

        }
      }

      axios
        .post('permits/getStpStepData', dr)
        .then(response => {
          this.VM.currentStepId = this.STEPIDS.stepFinish;
          this.VM.stepFinish.alert = response.data.stepFinish.alert;
          this.VM.jumpToCart = response.data.jumpToCart;
        })
        .catch(error => console.log(error))
        .finally(() => {
          if (this.VM.jumpToCart) {
            this.redirectToFullURL(this.VM.shoppingCartWebAddress);
          }
          this.loader.loading = false;
        });
    }
    //#endregion

    //cart
    permitCartItemChanged() {
      if (!(this.VM.permitCart && this.VM.permitCart.calculatedFees)) return;

      var i = 0;
      for (i = 0; i < this.VM.permitCart.calculatedFees.length; i++) {
        if (this.VM.permitCart.calculatedFees[i].canBeOnAccount) {
          this.VM.permitCart.calculatedFees[i].isOnAccount = (this.VM.permitCart.calculatedFees[i].onAccountId > 0);
        }
      }

      var hasOnAccount = false;
      var totalOnAccountFee = 0;
      var totalDisplayFee = 0;
      for (i = 0; i < this.VM.permitCart.calculatedFees.length; i++) {
        if (this.VM.permitCart.calculatedFees[i].isOnAccount) {
          hasOnAccount = true;
          totalOnAccountFee = totalOnAccountFee + this.VM.permitCart.calculatedFees[i].totalFee;
        }
        else {
          totalDisplayFee = totalDisplayFee + this.VM.permitCart.calculatedFees[i].totalFee;
        }
      }

      this.VM.permitCart.hasOnAccount = hasOnAccount;
      this.VM.permitCart.totalOnAccountFee = totalOnAccountFee;
      this.VM.permitCart.totalDisplayFee = totalDisplayFee;
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }

  }
